import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'

export const Card = styled('div')<{
    theme?: TTheme
    onClick?: () => void
    disabled?: boolean
    compact?: boolean
}>`
    display: flex;
    align-items: center;
    width: ${({ compact }) => (compact ? '330px' : '345px')};
    height: ${({ compact }) => (compact ? '64px' : '80px')};
    padding: 10px 20px;
    background: ${({ theme }) => theme?.colors.semantic.backgroundSecondary};
    border: 1px solid ${({ theme }) => theme?.colors.greys[200]};
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: ${({ theme }) =>
        theme?.colors.semantic.integrationCardBoxShadow};

    ${({ disabled }) =>
        disabled
            ? `
        pointer-events: none;
        opacity: 0.7;
    `
            : ''}

    &:hover {
        border-color: ${({ theme }) =>
            theme?.colors.semantic.integrationCardHoverBorder};
        box-shadow: ${({ theme }) =>
            theme?.colors.semantic.integrationCardHoverBoxShadow};
    }
`

export const IconSlot = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    height: 56px;
    width: 56px;
`

export const Content = styled('div')<{ theme?: TTheme; hasSubtitle?: boolean }>`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${({ hasSubtitle }) => (hasSubtitle ? '2px' : '0')};
`

export const Title = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors.greys[700]};
    text-align: left;
`

export const Subtitle = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors.greys[500]};
`

export const ArrowButton = styled('div')<{ theme?: TTheme }>`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${({ theme }) => theme?.colors.primary[400]};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s ease;

    &:hover {
        background: ${({ theme }) =>
            theme?.colors.semantic.integrationCardArrowButtonHover};
    }
`

export const Arrow = styled('div')<{ theme?: TTheme }>`
    color: white;
    font-size: var(--font-size-m);
    font-weight: var(--font-weight-bold);
`
